@if (field.sequentialView && isLanding) {
  <div class="common-text-input__container">
    <div class="common-text-field__container-box-sequential">
      @if (fieldTypeRichText.titleField) {
        <div class="common-text-field__block-header">
          <div class="common-text-field__label">
            <span class="common-text-input__text-label-sequential">{{fieldTypeRichText.titleField}}</span>
          </div>
        </div>
      }
      <div [ngClass]="field.isHighlight?'common-text-field__body-container-highlight':'common-text-field__body-container'">
        @if (field.isHighlight) {
          <i class="lf-icon-bookmarks-active common-text-field__icon-highlight"></i>
        }
        <div class="common-text-field__text-value-sequential"
          [id]="'field-type-rich-'+field.fieldId"
          [attr.disabled]="field.noEditable?true:null"
          [innerHTML]="fieldTypeRichText.descriptionPadding | trustHtml"></div>
      </div>
     </div>
  </div>
}@else {
  <div class="common-text-input__container"
    [id]="field.id">
    <div [ngClass]="field.isHighlight?'common-text-field__container-box-highlight':'common-text-field__container-box-default'">
      @if (fieldTypeRichText.titleField) {
        <div [ngClass]="field.isHighlight?'common-text-field__block-header-highlight':'common-text-field__block-header'">
          <label class="common-text-field__label">
            <span class="common-text-input__text-label">{{fieldTypeRichText.titleField}}</span>
            <div class="common-text-input__block-buttons">
              @if (field.references?.length) {
                <tooltip-law [references]="field.references"
                [field]="field"></tooltip-law>
              }
              @if (field.relatedInfo?.length) {
                <button class="common-button__icon-sm-noborder"
                  pTooltip="{{'common.related-info'| afTranslate}}"
                  tooltipPosition="top"
                  (click)="openModalRelatedInfo(field.relatedInfo, $event)">
                  <i class="lf-icon-search-text common-icon__md"></i>
                </button>
              }
              @if (field.inReport !== null && field.inReport !== undefined && !isLanding){
                <tooltip-in-report [inReport]="fieldTypeRichText.inReport"></tooltip-in-report>
              }
            </div>
          </label>
          @if (productTypeId === 4 && !isLanding) {
            <button class="common-button__icon-sm-noborder"
              (click)="shareField(field)">
              <i class="lf-icon-share common-icon__md"></i>
            </button>
          }
        </div>
      }
      <div [ngClass]="field.isHighlight?'common-text-field__body-container-highlight':'common-text-field__body-container'">
        @if (field.isHighlight) {
          <i class="lf-icon-bookmarks-active common-text-field__icon-highlight"></i>
        }
        <div class="common-text-field__text-value"
          [id]="'field-type-rich-'+field.fieldId"
          [attr.disabled]="field.noEditable?true:null"
          [innerHTML]="fieldTypeRichText.descriptionPadding | trustHtml"></div>
      </div>
    </div>
  </div>
}
